import React from 'react';

const defaultValues = {
  selectedItems: [],
  setSelectedItems: () => {},
  pageTableSetup: {
    header: {
      tr: {},
      th: []
    },
    body: {
      tr: {},
      td: []
    }
  }
};

const DefaultPageContext = React.createContext(defaultValues);

export default DefaultPageContext;
